
// Compra/Venta de mercado de sociadades de inversión
// Retiro de cuenta de inversión
// Retiro con venta de sociades de inversión

import { CBNavigationItem } from '@core/components/navigation';

export const defaultNavigation: CBNavigationItem[] = [
  {
    id: "operation",
    title: "Operación",
    subtitle: "Opera tus emisoras y fondos de inversión",
    type: "group",
    icon: "heroicons_outline:document",
    children: [
      {
        id: "operation.market",
        title: "Compra/Venta de mercado de capitales",
        type: "basic",
        icon: "feather:pie-chart",
        subtitle: "Mercado de capitales",
        link: "/operaciones/mercadoCapitales",
        codeScreen:"101000",
      },
      {
        id: "operation.investmentFunds",
        title: "Compra/Venta de fondos de inversión",
        type: "basic",
        icon: "heroicons_outline:presentation-chart-line",
        subtitle: "Fondos de inversión",
        link: "/operaciones/fondosInversion",
        codeScreen:"102000",
        
      },
      {
        id: "operation.retireAccount",
        title: "Retiros",
        type: "group",
        icon: "feather:external-link",
        subtitle: "Retiros a mi cuenta beneficios",
        classes: { icon: "text-blue" },
        children: [
          {
            id: "operation.retireAccount.retireSocInvestment",
            title: "Retiro con venta de fondos de inversión",
            type: "basic",
            icon: "feather:external-link",
            link: "/operaciones/retiro/venta",
            classes: { title: 'text-base',  icon: 'icon-size-4' },
            codeScreen:"103010",
            
          },
          {
            id: "operation.retireAccount.retireAccountInvestment",
            title: "Retiro de cuenta de inversión",
            type: "basic",
            icon: "feather:external-link",
            link: "/operaciones/retiro/cuenta",
            classes: { title: 'text-base',  icon: 'icon-size-4' },
            codeScreen:"103020",
            
          },

        ]
      },
    ],
  },
  {
    id: "divider-1",
    type: "divider",
  },
  {
    id: "consult",
    title: "Consulta",
    subtitle: "Consulta información de interés",
    type: "group",
    icon: "heroicons_outline:home",
    children: [
      {
        id: "consult.saldos",
        title: "Consulta saldos",
        type: "basic",
        icon: "heroicons_outline:academic-cap",
        link: '/consulta/saldos',
        codeScreen:"105010",
        
      },
      {
        id: "consult.estadoCuentas",
        title: "Estado de Cuenta",
        type: "basic",
        icon: "heroicons_outline:calendar",
        link: '/consulta/informacion/estados-de-cuenta',
        codeScreen:"105110",
        
      },
      {
        id: "consult.estadoCuentas",
        title: "Consulta Movimientos",
        type: "basic",
        icon: "heroicons_outline:calendar",
        link: '/consulta/informacion/movimientos',
        codeScreen:"105120",
        
      },
      {
        id: "consult.retencion",
        title: "Constancia de retención",
        type: "basic",
        icon: "heroicons_outline:chat-alt",
        link: '/consulta/documentos/carta-retencion',
        codeScreen:"105210",
        
      }
    ],
  },
  {
    id: "divider-2",
    type: "divider",
  },
  // {
  //   id: "information",
  //   title: "Información",
  //   subtitle: "Información financiera",
  //   type: "group",
  //   icon: "heroicons_outline:information-circle",
  //   children: [
  //     {
  //       id: "information.financiera",
  //       title: "Información económica financiera",
  //       subtitle: "Información económica financiera",
  //       type: "basic",
  //       icon: "heroicons_outline:chip",
  //       link: "/informacion/financiera",
  //       codeScreen:"110010",
        
  //     }
  //   ]
  // },
  // {
  //   id: "divider-3",
  //   type: "divider",
  // }
];

export const horizontalNavigation: CBNavigationItem[] = [

  {
    id: "operation",
    title: "Operación",
    type: "group",
    icon: "heroicons_outline:trending-up",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "consult",
    title: "Consulta",
    type: "group",
    icon: "heroicons_outline:search-circle",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  // {
  //   id: "information",
  //   title: "Información",
  //   type: "group",
  //   icon: "heroicons_outline:information-circle",
  //   children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  // }

];

export const compactNavigation: CBNavigationItem[] = [];
export const futuristicNavigation: CBNavigationItem[] = []


